import React from "react";
export const DataTableShadowComponent = ({ children }) => {
  return (
    <div className="rt-table shadow pr-0  rounded" role="grid">
      {" "}
      {children}{" "}
    </div>
  );
};
